/**
 * Image Zoom Component
 * 
 * Simple example showing how to add JavaScript to a snippet
 * This adds hover zoom functionality to images
 */

export default class ImageZoom {
  constructor(element) {
    this.element = element;
    this.image = element.querySelector('img');
    
    if (this.image) {
      this.init();
    }
  }

  init() {
    console.log('🔍 Image zoom initialized');
    
    this.element.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
    this.element.addEventListener('mousemove', this.handleMouseMove.bind(this));
    this.element.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
  }

  handleMouseEnter() {
    this.element.classList.add('is-zoomed');
  }

  handleMouseMove(e) {
    const rect = this.element.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    
    this.image.style.transformOrigin = `${x}% ${y}%`;
  }

  handleMouseLeave() {
    this.element.classList.remove('is-zoomed');
    this.image.style.transformOrigin = 'center center';
  }
}

